























































































































































































































import { Component, Mixins, Prop, Inject } from "vue-property-decorator";
import RequestPromises from "@/mixins/requestPromises";
import Context from "@/mixins/context";
import {
  ILegacyInvoiceProviderData,
  ILegacyInvoiceProviderMethods
} from "@/models/providers/legacyInvoices";

@Component({
  components: {
    "invoice-details-skeleton": () =>
      import("@/components/app/global/invoices/invoiceDetailsSkeleton.vue"),
    "invoice-paid-stamp": () =>
      import("@/components/app/global/invoices/invoicePaidStamp.vue")
  }
})
export default class LegacyInvoiceDetails extends Mixins(
  RequestPromises,
  Context
) {
  // Inject

  @Inject({ from: "legacyInvoiceProviderData" })
  public readonly $legacyInvoiceProviderData!: () => ILegacyInvoiceProviderData;

  @Inject({ from: "legacyInvoiceProviderMethods" })
  public readonly $invoiceMethods!: ILegacyInvoiceProviderMethods;

  // Props

  @Prop({ default: true })
  public canDownload!: boolean;

  // Computed

  public get $invoiceData() {
    return this.$legacyInvoiceProviderData();
  }
}
